export default __webpack_public_path__ + "static/media/Gilroy-Regular.ebe86c03.woff";